module.exports = __webpack_public_path__ + "static/img/banner_txt1_new.2bb9fee.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/banner_txt1_new.png
// module id = 2cIj
// module chunks = 0